export function objectToOptions(array) {
  const options = [];
  if (array) {
    array.map((object) => {
      options.push(object.regionName);
    });
  }

  return options;
}

export function arrayToOptions(array) {
  const options = [];
  if (array) {
    array.map((object) => {
      options.push(object.name);
    });
  } else {
    return false;
  }

  return options;
}

/**
 * Normalize empty/absent values so "" and undefined/null compare equal.
 */
function normalizeEmpty(val) {
  if (val == null || val === "") return null;
  return val;
}

/**
 * Value-aware equality for discard detection (handles pointers by id, primitives by value).
 * Treats "" and undefined/null as equal (no value).
 */
function isValueEqual(a, b) {
  if (a === b) return true;
  const na = normalizeEmpty(a);
  const nb = normalizeEmpty(b);
  if (na == null && nb == null) return true;
  if (na == null || nb == null) return false;
  if (
    typeof na === "object" &&
    typeof nb === "object" &&
    !Array.isArray(na) &&
    !Array.isArray(nb)
  ) {
    if (na.id != null && nb.id != null) return na.id === nb.id;
    try {
      return JSON.stringify(na) === JSON.stringify(nb);
    } catch {
      return false;
    }
  }
  return String(na) === String(nb);
}

/**
 * Returns true if formData (obj1) has any value that differs from the original object (obj2).
 * Only compares keys that exist on the original object (obj2) so form-only keys and
 * extra keys on object (id, created, etc.) don't cause false positives.
 */
export function hasShallowChanges(obj1, obj2) {
  if (!obj2 || Object.keys(obj2).length === 0) {
    return false;
  }

  for (const key of Object.keys(obj2)) {
    if (!isValueEqual(obj1[key], obj2[key])) {
      return true;
    }
  }

  return false;
}

export function isAddressSame(obj) {
  if (!obj) return false;

  const normalize = (val) =>
    String(val || "")
      .trim()
      .toLowerCase();

  return ["Region", "Province", "City"].every(
    (field) =>
      normalize(obj[`shipping${field}`]) === normalize(obj[`billing${field}`])
  );
}

export function formatTinNo(inputtedValue) {
  const stringValue = String(inputtedValue ?? "");

  const digitsOnly = stringValue.replace(/\D/g, "").substring(0, 14);

  if (digitsOnly.length === 0) return "";

  let formatted = digitsOnly;

  if (digitsOnly.length > 3 && digitsOnly.length <= 6) {
    formatted = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`;
  } else if (digitsOnly.length > 6 && digitsOnly.length <= 9) {
    formatted = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(
      3,
      6
    )}-${digitsOnly.slice(6)}`;
  } else if (digitsOnly.length > 9) {
    formatted = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(
      3,
      6
    )}-${digitsOnly.slice(6, 9)}-${digitsOnly.slice(9)}`;
  }

  return formatted;
}
